import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, map } from 'rxjs';
import { environment } from '../../environments/environment';
import { AmbassadorProgramCompanyUserDTO } from '../models/ambassador-program-company-user-dto';
import { DataTablesResponse } from '../models/datatables';
import { AmbassadorContractStatusDTO } from '../models/ambassador-contract-status-dto';
import { AmbassadorFileDTO } from '../models/ambassador-file-dto';
import { Select2Data } from 'ng-select2-component';

@Injectable({
  providedIn: 'root'
})

export class AmbassadorProgramCompanyUserService {

  private pathAPI = environment.urlAPI;
  private controller = "AmbassadorProgramCompanyUser/";

  public programCompanyUserData = new BehaviorSubject<AmbassadorProgramCompanyUserDTO>(null);

  constructor(private http: HttpClient) { }

  public initializeProgramCompanyUserData() {
    const that = this;
    this.getProgramCompanyUserInfo().subscribe(resp => {
      that.setProgramCompanyUserData(resp);
    });
  }

  public getProgramCompanyUserInfo(): Observable<AmbassadorProgramCompanyUserDTO> {
    return this.http.get<AmbassadorProgramCompanyUserDTO>(this.pathAPI + this.controller + 'GetLoggedUserInfo');
  }

  setProgramCompanyUserData(user: AmbassadorProgramCompanyUserDTO) {
    this.programCompanyUserData.next(user);
  }

  getProgramCompanyUserData(): Observable<AmbassadorProgramCompanyUserDTO> {
    if (this.programCompanyUserData.value != null) {
      return this.programCompanyUserData.asObservable();
    }
    else {
      return this.getProgramCompanyUserInfo().pipe(map((userData) => {
        this.programCompanyUserData.next(userData);
        return userData;
      }),
        catchError((err) => {
          return this.programCompanyUserData.asObservable();
        }));
    }
  }

  clearProgramCompanyUserData() {
    this.programCompanyUserData.next(null);
  }

  public updateLoggedUser(data: FormData): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'UpdateLoggedUser', data);
  }

  public resetReservation(): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ResetReservation', null);
  }

  public get(id: string): Observable<AmbassadorProgramCompanyUserDTO> {
    return this.http.get<AmbassadorProgramCompanyUserDTO>(this.pathAPI + this.controller + id);
  }

  public post(data: FormData): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public put(id: string, data: FormData): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public delete(id: string): Observable<any> {
    return this.http.delete<any>(this.pathAPI + this.controller + id);
  }

  public getDataTable(data: any, idFilters: string): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable/' + idFilters, data);
  }

  public getAllForSelect(idProgram: string, idCompany: string): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetAllForSelect/' + idProgram + '/' + idCompany);
  }

}
